import React from 'react';
import '../../styles/components.css';

const PageLoader = () => {
    return (
        <div className="pageloader">
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        </div>
    );
};

export default PageLoader;